import validate from "/usr/src/app/content/n3-packages-10195878-059f-4a05-875e-0682ac06727f/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-packages-10195878-059f-4a05-875e-0682ac06727f/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}